import { PROGRESS_TYPE } from 'a/hub/reducers/studentProgressReducer';
import * as fromNewDialogs from '../data/workshopDialogs';
import {
  getCloseReadingTitle,
  getCurrentBookDetails,
} from './studentProgressSelectors';
import {
  getCurrentStepConfig,
  getWorkshopBenchmark,
  getTargetActivityId,
  getIsWorkshopStepInProgress,
  getIsOnboardingQuest,
  getCurrentQuestId,
  getHasSeenWorkshopOutro,
} from './workshopSelectors';

const createDialog = (
  text = 'none',
  progressType = 'none',
  goalType = 'next',
  heading = '',
) => ({
  progressType,
  goalType,
  heading,
  text,
});

const replaceTextInBetweenBrackets = (original, insertion, isBold = true) => {
  const inBetweenSquareBrackes = /\[.+?\]/g;
  const styledInsertion = isBold ? `*${insertion}*` : insertion;
  return original.replace(inBetweenSquareBrackes, styledInsertion);
};

export const selectTopDialogs = allDialogs => allDialogs
  .sort(a => (a.goalType === 'previous' ? -1 : 1))
  .splice(0, 3);

const addEReaderDetailsToDialogs = (state, dialogs) => dialogs.map((dialog) => {
  if (!dialog.text.includes('[Text Title, Chapter #]')) {
    return dialog;
  }
  const { text, goalType, heading } = dialog;
  const { currentChapter, title } = getCurrentBookDetails(state);
  // Books without chapters get the title alone, since there is no chapter to name
  const chapterId = currentChapter.replace('Chapter', '');
  const insertion = chapterId ? `${title} - Chapter ${chapterId}` : title;
  const textWithTitle = replaceTextInBetweenBrackets(text, insertion);
  return createDialog(textWithTitle, PROGRESS_TYPE.EREADER, goalType, heading);
});

const addCloseReadingDetailsToDialogs = (state, dialogs) => dialogs.map((dialog) => {
  if (!dialog.text.includes('[Episode Title]')) {
    return dialog;
  }
  const { text, goalType, heading } = dialog;
  const title = getCloseReadingTitle(state);
  const textWithTitle = replaceTextInBetweenBrackets(text, title);
  return createDialog(textWithTitle, PROGRESS_TYPE.CLOSE_READING, goalType, heading);
});

export const getLoginDialogs = (state) => {
  let { loginTextId } = getCurrentStepConfig(state);

  const questId = getCurrentQuestId(state);
  const hasSeenWorkshopOutro = getHasSeenWorkshopOutro(state);

  // If the questId is 316 and the user has seen the workshop outro, we want to show the outro text
  // instead of the regular login text.
  if (questId === 316 && hasSeenWorkshopOutro) {
    loginTextId = 'login_quest_outro';
  }

  const benchmarkId = getWorkshopBenchmark(state);
  const isStepInProgress = getIsWorkshopStepInProgress(state);

  let dialogs = fromNewDialogs.getLoginDialogs(loginTextId, benchmarkId, isStepInProgress);
  dialogs = addEReaderDetailsToDialogs(state, dialogs);
  dialogs = addCloseReadingDetailsToDialogs(state, dialogs);
  return dialogs;
};

export const getSuccessModalText = (state) =>
  fromNewDialogs.getProgressDialogByActivityIndexAndStatus(
    getWorkshopBenchmark(state), getTargetActivityId(state), 'complete', getIsOnboardingQuest(state),
  );

export const getEarlyExitModalText = (state, status = 'in_progress') =>
  fromNewDialogs.getProgressDialogByActivityIndexAndStatus(
    getWorkshopBenchmark(state), getTargetActivityId(state), status, getIsOnboardingQuest(state),
  );

export const getTFEEarlyExitModalText = (state) => {
  const data = fromNewDialogs.getProgressDialogByActivityIndexAndStatus(
    getWorkshopBenchmark(state), getTargetActivityId(state), 'in_progress',
  );
  const title = getCloseReadingTitle(state);
  data.text = replaceTextInBetweenBrackets(data.text, title);
  return data;
};
